import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "./utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium shadow-sm transition-all duration-300 ease-out active:scale-[0.97] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white",
  {
    variants: {
      variant: {
        default: "bg-gradient-to-r from-amber-500 to-green-700 text-white hover:from-amber-600 hover:to-green-800 active:from-amber-700 active:to-green-900",
        destructive:
          "bg-red-600 text-white hover:bg-red-700 active:bg-red-800",
        outline:
          "border border-slate-300 bg-white text-slate-800 hover:bg-slate-50 active:bg-slate-100",
        secondary:
          "bg-slate-800 text-white hover:bg-slate-900 active:bg-slate-950",
        ghost:
          "text-slate-800 hover:bg-slate-100 active:bg-slate-200",
        link: "text-green-700 underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2 min-w-[44px] min-h-[44px]",
        sm: "h-8 px-3 py-1.5 text-xs min-w-[36px] min-h-[36px]",
        lg: "h-12 px-6 py-3 text-base min-w-[48px] min-h-[48px]",
        icon: "size-10 min-w-[44px] min-h-[44px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        data-slot="button"
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
